export const Guard = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>;
};
